import React from "react";
import { Row, Col, Card, ProgressBar, Table } from "react-bootstrap";

const Dashboard = () => {
  return (
    <div className="p-4">
      <h2 className="mb-4">Dashboard</h2>
      <p>Welcome to Admin Panel</p>

      <Row className="mb-4">
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm text-center p-3">
            <h5>Total Users</h5>
            <h2>1,245</h2>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm text-center p-3">
            <h5>Active Projects</h5>
            <h2>87</h2>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm text-center p-3">
            <h5>New Orders</h5>
            <h2>542</h2>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm text-center p-3">
            <h5>Revenue</h5>
            <h2>$12.4K</h2>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6} className="mb-3">
          <Card className="shadow-sm p-3">
            <h5>Project Completion</h5>
            <p>Website Redesign</p>
            <ProgressBar now={70} label={`70%`} className="mb-2" />
            <p>App Development</p>
            <ProgressBar now={45} label={`45%`} />
          </Card>
        </Col>

        <Col md={6} className="mb-3">
          <Card className="shadow-sm p-3">
            <h5>Recent Orders</h5>
            <Table striped hover responsive className="mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order</th>
                  <th>Status</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Website Design</td>
                  <td>Completed</td>
                  <td>$1,200</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>App Development</td>
                  <td>In Progress</td>
                  <td>$3,400</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Marketing Campaign</td>
                  <td>Pending</td>
                  <td>$800</td>
                </tr>
              </tbody>
            </Table>
          </Card>
        </Col>
      </Row>

      
    </div>
  );
};

export default Dashboard;
